import axios, {AxiosError, AxiosInstance, AxiosRequestConfig} from 'axios';
import {Vue} from "vue-property-decorator";
import {Apis} from "@/api/index";



export class Api {

    baseURL = process.env.NODE_ENV === "production" ? "/api" : "http://localhost:8080/api"
    protected axios: AxiosInstance
    token = ""

    constructor(groupName = "") {
        this.axios = axios.create({
            baseURL: this.baseURL + groupName,
            timeout: 10000,
        })
    }


    async call(url: string, data?: any, config?: AxiosRequestConfig) {
        let response: ApiResponse

        try {
            const res = await this.axios.post(url, data, config)
            response = res.data
        } catch (e) {
            console.log("api failed", url, data, e, e.response)
            if (e.isAxiosError) {
                const err = e as AxiosError
                //重新登录
                if (err.response?.status == 401) {
                    // window.location.href = "/login"

                    //清除localStorage
                    const storage = window.localStorage;
                    storage.clear()

                    window.location.href = "https://openapi.wps.cn/oauthapi/v2/authorize?appid=AK20210507FUOARL&response_type=code&redirect_uri="+window.location.protocol+"//" + window.location.host + "/&scope=user_info"

                    return
                }
                Vue.prototype.$message.error(err.response?.data.errmsg ?? "网络连接失败:" + err.response?.status)
            }
            return null
        }

        if (response.errno != 0) {
            Vue.prototype.$message.error(response.errmsg)
            return response
        }
        return response
    }
}
